import {
  Elements,
} from '@stripe/react-stripe-js'
import { loadStripe, type StripeElementsOptions } from '@stripe/stripe-js'
import { useMemo } from 'react'

import LoadingSpinnerCentered from 'components/reusable/LoadingSpinnerCentered'

import StripePaymentForm from './StripePaymentForm'
import { colors } from '../../../../../../../config/tailwind/colors'

export type Props = {
  stripePublishableKey: string;
}

const ELEMENTS_OPTIONS: StripeElementsOptions = {
  mode: 'setup',
  paymentMethodTypes: ['card'],
  paymentMethodCreation: 'manual',
  appearance: {
    theme: 'stripe',
    inputs: 'condensed',
    variables: {
      colorPrimary: colors.primitive.thatch[500],
      colorText: colors.primitive.gray[800],
      borderRadius: '8px',
    },
  },
}

export default function StripePayment ({
  stripePublishableKey,
}: Props) {
  const stripePromise = useMemo(() => {
    return stripePublishableKey ? loadStripe(stripePublishableKey) : null
  }, [stripePublishableKey])

  if (!stripePromise) {
    return (
      <div className='flex items-center justify-center'>
        <LoadingSpinnerCentered height='4rem' width='4rem' />
      </div>
    )
  }

  return (
    <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
      <StripePaymentForm />
    </Elements>
  )
}
